import React, { PureComponent } from "react";
export class DeviceIcon extends PureComponent {
  props: Object;
  render() {
    const { ...rest } = this.props;
    return (
      <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" {...rest}>
        <title>Sensor-32x32</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Sensor-32x32" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="ic_wifi_tethering_24px" transform="translate(1.000000, 2.000000)" fill="#111111" fillRule="nonzero">
            <path
              d="M15,12 C13.35,12 12,13.35 12,15 C12,16.65 13.35,18 15,18 C16.65,18 18,16.65 18,15 C18,13.35 16.65,12 15,12 Z M24,15 C24,10.035 19.965,6 15,6 C10.035,6 6,10.035 6,15 C6,18.33 7.815,21.225 10.5,22.785 L12,20.175 C10.215,19.125 9,17.22 9,15 C9,11.685 11.685,9 15,9 C18.315,9 21,11.685 21,15 C21,17.22 19.785,19.125 18,20.175 L19.5,22.785 C22.185,21.225 24,18.33 24,15 Z M15,0 C6.72,0 0,6.72 0,15 C0,20.55 3.015,25.38 7.485,27.975 L8.985,25.38 C5.415,23.295 3,19.44 3,15 C3,8.37 8.37,3 15,3 C21.63,3 27,8.37 27,15 C27,19.44 24.585,23.295 21,25.38 L22.5,27.975 C26.985,25.38 30,20.55 30,15 C30,6.72 23.28,2.66453526e-15 15,0 Z"
              id="Shape"
            />
          </g>
        </g>
      </svg>
    );
  }
}
export default DeviceIcon;



// WEBPACK FOOTER //
// ./src/_icons/DeviceIcon/index.js